// import React, { Component } from 'react';
// import { Link } from 'react-router-dom';
// // import Ico from './iconBox';




// import PropertyList from "./allProperties";
// import properties from "./Yovho.properties.json";
// import SearchBar from "./SearchBar";
// import  "./sidebar.css";




// import Slider1 from '../img/Karachi-Travel-Guide-Travel-S-Helper-copy-1024x640.jpg';
// import Slider2 from '../img/cover-image-2019-10-17T124521.228.jpg';





// import smallReview1 from '../img/4 (1).jpg';


// import About1 from '../img/9 (1).jpg';
// import About2 from '../img/10 (1).jpg';
// import About3 from '../img/8 (1).jpg';
// import About4 from '../img/7 (1).jpg';


// import BookingForm from "./BookingForm"


// class Home extends Component {
//     state = {

//     }
//     componentDidMount(){
//         window.scrollTo(0, 0)

//     }
//     render() {
//         return (
//             <div>
            
       
















// <>


//       <SearchBar />

//   <br />











//  <div className="container">
//     <div className="row">
//     <div className="col-lg-3">



// <div class="sidebar">
//   {/* <!-- Map --> */}
//   {/* <div class="map-container">
//     <img src="https://via.placeholder.com/300x150.png?text=Map+Preview" alt="Map"/>
//     <button>Show on map</button>
//   </div> */}

//   {/* <!-- Filters --> */}
//   <div class="filter-section">
//     <h3>Filter by:</h3>

//     {/* <!-- Budget --> */}
//     <div class="budget-range">
//       <strong>Your budget (per night)</strong><br/>
//       PKR 1,000 – PKR 30,000+
//       <input type="range" min="1000" max="30000" value="15000" style={{width:"100%"}}/>
//     </div>

//     {/* <!-- General Options --> */}
//     <div class="filter-options">
//       <label><span><input type="checkbox"/> No prepayment </span><span>349</span></label>
//       <label><span><input type="checkbox"/> Free cancellation </span><span>100</span></label>
//       <label><span><input type="checkbox"/> Hot tub </span><span>12</span></label>
//       <label><span><input type="checkbox"/> Sauna </span><span>5</span></label>
//       <label><span><input type="checkbox"/> Toilet </span><span>288</span></label>
//       {/* <label><span><input type="checkbox"/> Mountain view</label> */}
//       <label><span><input type="checkbox"/> Towels </span><span>287</span></label>
//       <label><span><input type="checkbox"/> Hotels </span><span>124</span></label>
//     </div>

// <hr />
// <hr />
//     {/* <!-- Property Type --> */}
//     <h4>Property Type</h4>
//     <div class="filter-options">
//       <label><span><input type="checkbox"/> Guesthouses </span><span>151</span></label>
//       <label><span><input type="checkbox"/> Apartments </span><span>139</span></label>
//       <label><span><input type="checkbox"/> Hotels </span><span>136</span></label>
//       <label><span><input type="checkbox"/> Villas </span><span>25</span></label>
//       <label><span><input type="checkbox"/> Bed & Breakfasts </span><span>24</span></label>
//       <label><span><input type="checkbox"/> Vacation Homes </span><span>24</span></label>
//       <label><span><input type="checkbox"/> Homestays </span><span>11</span></label>
//       <label><span><input type="checkbox"/> Hostels </span><span>3</span></label>
//       <label><span><input type="checkbox"/> Resorts </span><span>3</span></label>
//       <label><span><input type="checkbox"/> Farm Stays </span><span>2</span></label>
//       <label><span><input type="checkbox"/> Capsule Hotels </span><span>2</span></label>
//       <label><span><input type="checkbox"/> Motels </span><span>1</span></label>
//       <label><span><input type="checkbox"/> Resort Villages </span><span>1</span></label>
//       <label><span><input type="checkbox"/> Love Hotels </span><span>1</span></label>
//     </div>
// <hr />
// <hr />
//     {/* <!-- Property Facilities --> */}
//     <h4>Property Facilities</h4>
//     <div class="filter-options">
//       <label><span><input type="checkbox"/> Parking </span><span>475</span></label>
//       <label><span><input type="checkbox"/> Restaurant </span><span>70</span></label>
//       <label><span><input type="checkbox"/> Room service </span><span>191</span></label>
//       <label><span><input type="checkbox"/> 24-hour front desk </span><span>178</span></label>
//       <label><span><input type="checkbox"/> Fitness center </span><span>28</span></label>
//       <label><span><input type="checkbox"/> Non-smoking rooms </span><span>233</span></label>
//       <label><span><input type="checkbox"/> Airport shuttle </span><span>131</span></label>
//       <label><span><input type="checkbox"/> Spa </span><span>13</span></label>
//       <label><span><input type="checkbox"/> Hot tub/Jacuzzi </span><span>44</span></label>
//       <label><span><input type="checkbox"/> Free Wifi </span><span>345</span></label>
//       <label><span><input type="checkbox"/> EV charging </span><span>8</span></label>
//       <label><span><input type="checkbox"/> Wheelchair accessible </span><span>41</span></label>
//     </div>
// <hr />
// <hr />
//     {/* <!-- Property Rating --> */}
//     <h4>Property Rating</h4>
//     <div class="filter-options">
//       <label><span><input type="checkbox"/> 1 star </span><span>8</span></label>
//       <label><span><input type="checkbox"/> 2 stars </span><span>21</span></label>
//       <label><span><input type="checkbox"/> 3 stars </span><span>110</span></label>
//       <label><span><input type="checkbox"/> 4 stars </span><span>31</span></label>
//       <label><span><input type="checkbox"/> 5 stars </span><span>16</span></label>
//     </div>
// <hr />
// <hr />
//     {/* <!-- Review Score --> */}
//     <h4>Review Score</h4>
//     <div class="filter-options">
//       <label><span><input type="checkbox"/> Wonderful: 9+ </span><span>91</span></label>
//       <label><span><input type="checkbox"/> Very Good: 8+ </span><span>147</span></label>
//       <label><span><input type="checkbox"/> Good: 7+ </span><span>205</span></label>
//       <label><span><input type="checkbox"/> Pleasant: 6+ </span><span>232</span></label>
//     </div>
// <hr />
// <hr />
//     {/* <!-- Reasons to Visit --> */}
//     <h4>Reasons to Visit</h4>
//     <div class="filter-options">
//       <label><span><input type="checkbox"/> Business </span><span>175</span></label>
//       <label><span><input type="checkbox"/> Beaches </span><span>66</span></label>
//       <label><span><input type="checkbox"/> Sunny Weather </span><span>63</span></label>
//       <label><span><input type="checkbox"/> Family Friendly Trips </span><span>50</span></label>
//       <label><span><input type="checkbox"/> Carnival </span><span>24</span></label>
//       <label><span><input type="checkbox"/> Budget Friendly </span><span>6</span></label>
//       <label><span><input type="checkbox"/> Nature </span><span>4</span></label>
//       <label><span><input type="checkbox"/> Tropical Weather </span><span>4</span></label>
//       <label><span><input type="checkbox"/> Glacier Tours </span><span>3</span></label>
//       <label><span><input type="checkbox"/> Luxury Shopping </span><span>2</span></label>
//     </div>
// <hr />
// <hr />
//     {/* <!-- Neighborhood --> */}
//     <h4>Neighborhood</h4>
//     <div class="filter-options">
//       <label><span><input type="checkbox"/> D.H.A. </span><span>104</span></label>
//       <label><span><input type="checkbox"/> PECHS </span><span>38</span></label>
//       <label><span><input type="checkbox"/> Gulshan-E-Jamal </span><span>34</span></label>
//       <label><span><input type="checkbox"/> Clifton </span><span>33</span></label>
//       <label><span><input type="checkbox"/> Saddar Town </span><span>8</span></label>
//       <label><span><input type="checkbox"/> Shahrah-e-Faisal </span><span>8</span></label>
//       <label><span><input type="checkbox"/> Bath Island </span><span>4</span></label>
//       <label><span><input type="checkbox"/> Kehkashan </span><span>2</span></label>
//     </div>
// <hr />
// <hr />
//     {/* <!-- Room Facilities --> */}
//     <h4>Room Facilities</h4>
//     <div class="filter-options">
//       <label><span><input type="checkbox"/> Sea view </span><span>26</span></label>
//       <label><span><input type="checkbox"/> Balcony </span><span>319</span></label>
//       <label><span><input type="checkbox"/> Private bathroom </span><span>392</span></label>
//       <label><span><input type="checkbox"/> Private pool </span><span>8</span></label>
//       <label><span><input type="checkbox"/> Air conditioning </span><span>481</span></label>
//     </div>
// <hr />
// <hr />
//     {/* <!-- Accessibility --> */}
//     <h4>Accessibility</h4>
//     <div class="filter-options">
//       <label><span><input type="checkbox"/> Toilet with grab rails </span><span>18</span></label>
//       <label><span><input type="checkbox"/> Raised toilet </span><span>21</span></label>
//       <label><span><input type="checkbox"/> Lowered sink </span><span>17</span></label>
//       <label><span><input type="checkbox"/> Bathroom emergency cord </span><span>10</span></label>
//       <label><span><input type="checkbox"/> Visual aids (Braille) </span><span>7</span></label>
//       <label><span><input type="checkbox"/> Visual aids (tactile) </span><span>7</span></label>
//       <label><span><input type="checkbox"/> Auditory guidance </span><span>11</span></label>
//       <label><span><input type="checkbox"/> Entire unit ground floor </span><span>68</span></label>
//       <label><span><input type="checkbox"/> Elevator access </span><span>49</span></label>
//       <label><span><input type="checkbox"/> Wheelchair accessible </span><span>75</span></label>
//       <label><span><input type="checkbox"/> Adapted bath </span><span>13</span></label>
//       <label><span><input type="checkbox"/> Roll-in shower </span><span>18</span></label>
//       <label><span><input type="checkbox"/> Walk-in shower </span><span>39</span></label>
//       <label><span><input type="checkbox"/> Shower chair </span><span>14</span></label>
//     </div>
//   </div>
// </div>






//     </div>
//     <div className="col-lg-9">
//   <PropertyList properties={properties} />





//   {/* <PropertyList data={properties} />
//   <PropertyList data={properties} />
//   <PropertyList data={properties} /> */}


//         </div>
//     </div>
//     </div>






// </>



















        
//           </div>
//         )
//     }
// }

// export default Home;
















































































// import React, { useEffect, useState } from "react";

// import { Link , useNavigate} from 'react-router-dom';
// // import Ico from './iconBox';




// import PropertyList from "./allProperties";
// // import properties from "./Yovho.properties.json";
// import SearchBar from "./SearchBar";
// import  "./sidebar.css";




// import Slider1 from '../img/Karachi-Travel-Guide-Travel-S-Helper-copy-1024x640.jpg';
// import Slider2 from '../img/cover-image-2019-10-17T124521.228.jpg';





// import smallReview1 from '../img/4 (1).jpg';


// import About1 from '../img/9 (1).jpg';
// import About2 from '../img/10 (1).jpg';
// import About3 from '../img/8 (1).jpg';
// import About4 from '../img/7 (1).jpg';


// const SearchResults = () => {

//     const [allProperties, setAllProperties] = useState([]); // raw data



// const [properties, setProperties] = useState([]); // ✅ State for properties 
// const [loading, setLoading] = useState(true);





//   const [selectedTypes, setSelectedTypes] = useState([]);








//   const [budget, setBudget] = useState(50); // default slider value



//   const navigate = useNavigate();



//   function filterApprovedProperties(properties,bookingData   , budget1) {
//     if (budget1 === undefined){
//       budget1 = budget
//     }
//    return properties.data.properties
//       .filter((property) => property.status === "approved")
//       .map((property) => ({
//         ...property,
//         rooms: property.rooms
//           ? property.rooms.filter((room) => {
//               if (room.status !== "approved") return false;

//             const price = room.discount?.priceAfterDiscount && room.discount?.priceAfterDiscount > 0
//   ? room.discount.priceAfterDiscount
//   : room.nightlyPrice;

// console.log(price,budget1)

//               return price >= budget1; // ✅ budget filter
//             })
//           : [],
//       }))
//     .filter((property) => property.rooms.length > 0) // at least one room

//     .filter((property) => {
//       // Booking data ke according filter karna
//       const cityMatch =
//         bookingData?.destination &&
//         property.city?.toLowerCase() === bookingData.destination.toLowerCase();

//       const categoryMatch =
//         bookingData?.selectedOption &&
//         property.category?.toLowerCase() === bookingData.selectedOption.toLowerCase();


 


//       return cityMatch && categoryMatch ;
//     });
// }

// // Example usage:
// useEffect(() => {
//      window.scrollTo(0, 0)
//   const bookingData = JSON.parse(localStorage.getItem("BookingDate")) || {};

//       if (!bookingData) {
//       navigate("/");
//       return;
//     }

// fetch("https://striking-dedication-production.up.railway.app/api/v1/public/properties", 
//   { method: "GET", 
//     headers: { "Accept": "application/json", "Content-Type": "application/json", },
//    }) 
//    .then((res) => {
//      if (!res.ok) 
//       { throw new Error(`HTTP error! status: ${res.status}`);
//      } 
//      return res.json();
//      }) 
//      .then((data) => { 
//       console.log(data)
//       const approvedData = filterApprovedProperties(data,bookingData,budget);
//        setProperties(approvedData); 
//        setLoading(false);

//        }) 
//        .catch((err) => { 
//         console.error("Error fetching properties:", err);
//          setLoading(false); 
//         }); 

// }, [navigate,budget]);

//   // ✅ slider change -> filter apply
//   const handleBudgetChange = (e) => {
//     const newBudget = Number(e.target.value);
//     setBudget(newBudget);

//     const bookingData = JSON.parse(localStorage.getItem("BookingDate"));
//     if (allProperties?.data) {
//       const approvedData = filterApprovedProperties(allProperties, bookingData, newBudget);
//       setProperties(approvedData);
//     }
//   };

// if (loading) return <p>Loading...</p>;


// return(


//          <div>
      

// <>

//       <SearchBar />

//   <br />


//  <div className="container">
//     <div className="row">
//     <div className="col-lg-3">



// <div class="sidebar">
//   {/* <!-- Map --> */}
//   {/* <div class="map-container">
//     <img src="https://via.placeholder.com/300x150.png?text=Map+Preview" alt="Map"/>
//     <button>Show on map</button>
//   </div> */}

//   {/* <!-- Filters --> */}
//   <div class="filter-section">
//     <h3>Filter by:</h3>

//     {/* <!-- Budget --> */}
//     <div class="budget-range">
//       <strong>Your budget {budget} (per night)</strong><br/>
//       PKR 5,000 – PKR 100,000+
//       <input type="range" min="50" max="100000" 
//                            value={budget}
//                     onChange={handleBudgetChange}
//          style={{width:"100%"}}/>
//     </div>

//     {/* <!-- General Options --> */}
    

//     {/* <!-- Property Type --> */}
//     <h4>Property Type</h4>
//     <div class="filter-options">
//       <label><span><input type="checkbox"/> HOTEL STAY </span></label>
//       <label><span><input type="checkbox"/> APARTMENT STAY </span></label>
//       <label><span><input type="checkbox"/> HOME STAY </span></label>
//       <label><span><input type="checkbox"/> HOSTELS </span></label>
//     </div>
// <hr />
// <hr />
// <div class="filter-options">
//       <label><span><input type="checkbox"/> No prepayment </span><span>349</span></label>
//       <label><span><input type="checkbox"/> Free cancellation </span><span>100</span></label>
//       <label><span><input type="checkbox"/> Hot tub </span><span>12</span></label>
//       <label><span><input type="checkbox"/> Sauna </span><span>5</span></label>
//       <label><span><input type="checkbox"/> Toilet </span><span>288</span></label>
//       {/* <label><span><input type="checkbox"/> Mountain view</label> */}
//       <label><span><input type="checkbox"/> Towels </span><span>287</span></label>
//     </div>

// <hr />
// <hr />
//     {/* <!-- Property Facilities --> */}
//     <h4>Property Facilities</h4>
//     <div class="filter-options">
//       <label><span><input type="checkbox"/> Parking </span><span>475</span></label>
//       <label><span><input type="checkbox"/> Restaurant </span><span>70</span></label>
//       <label><span><input type="checkbox"/> Room service </span><span>191</span></label>
//       <label><span><input type="checkbox"/> 24-hour front desk </span><span>178</span></label>
//       <label><span><input type="checkbox"/> Fitness center </span><span>28</span></label>
//       <label><span><input type="checkbox"/> Non-smoking rooms </span><span>233</span></label>
//       <label><span><input type="checkbox"/> Airport shuttle </span><span>131</span></label>
//       <label><span><input type="checkbox"/> Spa </span><span>13</span></label>
//       <label><span><input type="checkbox"/> Hot tub/Jacuzzi </span><span>44</span></label>
//       <label><span><input type="checkbox"/> Free Wifi </span><span>345</span></label>
//       <label><span><input type="checkbox"/> EV charging </span><span>8</span></label>
//       <label><span><input type="checkbox"/> Wheelchair accessible </span><span>41</span></label>
//     </div>
// <hr />
// <hr />
//     {/* <!-- Property Rating --> */}
//     <h4>Property Rating</h4>
//     <div class="filter-options">
//       <label><span><input type="checkbox"/> 1 star </span><span>8</span></label>
//       <label><span><input type="checkbox"/> 2 stars </span><span>21</span></label>
//       <label><span><input type="checkbox"/> 3 stars </span><span>110</span></label>
//       <label><span><input type="checkbox"/> 4 stars </span><span>31</span></label>
//       <label><span><input type="checkbox"/> 5 stars </span><span>16</span></label>
//     </div>
// <hr />
// <hr />
//     {/* <!-- Review Score --> */}
//     <h4>Review Score</h4>
//     <div class="filter-options">
//       <label><span><input type="checkbox"/> Wonderful: 9+ </span><span>91</span></label>
//       <label><span><input type="checkbox"/> Very Good: 8+ </span><span>147</span></label>
//       <label><span><input type="checkbox"/> Good: 7+ </span><span>205</span></label>
//       <label><span><input type="checkbox"/> Pleasant: 6+ </span><span>232</span></label>
//     </div>
// <hr />
// <hr />
//     {/* <!-- Reasons to Visit --> */}
//     <h4>Reasons to Visit</h4>
//     <div class="filter-options">
//       <label><span><input type="checkbox"/> Business </span><span>175</span></label>
//       <label><span><input type="checkbox"/> Beaches </span><span>66</span></label>
//       <label><span><input type="checkbox"/> Sunny Weather </span><span>63</span></label>
//       <label><span><input type="checkbox"/> Family Friendly Trips </span><span>50</span></label>
//       <label><span><input type="checkbox"/> Carnival </span><span>24</span></label>
//       <label><span><input type="checkbox"/> Budget Friendly </span><span>6</span></label>
//       <label><span><input type="checkbox"/> Nature </span><span>4</span></label>
//       <label><span><input type="checkbox"/> Tropical Weather </span><span>4</span></label>
//       <label><span><input type="checkbox"/> Glacier Tours </span><span>3</span></label>
//       <label><span><input type="checkbox"/> Luxury Shopping </span><span>2</span></label>
//     </div>
// <hr />
// <hr />
//     {/* <!-- Neighborhood --> */}
//     <h4>Neighborhood</h4>
//     <div class="filter-options">
//       <label><span><input type="checkbox"/> D.H.A. </span><span>104</span></label>
//       <label><span><input type="checkbox"/> PECHS </span><span>38</span></label>
//       <label><span><input type="checkbox"/> Gulshan-E-Jamal </span><span>34</span></label>
//       <label><span><input type="checkbox"/> Clifton </span><span>33</span></label>
//       <label><span><input type="checkbox"/> Saddar Town </span><span>8</span></label>
//       <label><span><input type="checkbox"/> Shahrah-e-Faisal </span><span>8</span></label>
//       <label><span><input type="checkbox"/> Bath Island </span><span>4</span></label>
//       <label><span><input type="checkbox"/> Kehkashan </span><span>2</span></label>
//     </div>
// <hr />
// <hr />
//     {/* <!-- Room Facilities --> */}
//     <h4>Room Facilities</h4>
//     <div class="filter-options">
//       <label><span><input type="checkbox"/> Sea view </span><span>26</span></label>
//       <label><span><input type="checkbox"/> Balcony </span><span>319</span></label>
//       <label><span><input type="checkbox"/> Private bathroom </span><span>392</span></label>
//       <label><span><input type="checkbox"/> Private pool </span><span>8</span></label>
//       <label><span><input type="checkbox"/> Air conditioning </span><span>481</span></label>
//     </div>
// <hr />
// <hr />
//     {/* <!-- Accessibility --> */}
//     <h4>Accessibility</h4>
//     <div class="filter-options">
//       <label><span><input type="checkbox"/> Toilet with grab rails </span><span>18</span></label>
//       <label><span><input type="checkbox"/> Raised toilet </span><span>21</span></label>
//       <label><span><input type="checkbox"/> Lowered sink </span><span>17</span></label>
//       <label><span><input type="checkbox"/> Bathroom emergency cord </span><span>10</span></label>
//       <label><span><input type="checkbox"/> Visual aids (Braille) </span><span>7</span></label>
//       <label><span><input type="checkbox"/> Visual aids (tactile) </span><span>7</span></label>
//       <label><span><input type="checkbox"/> Auditory guidance </span><span>11</span></label>
//       <label><span><input type="checkbox"/> Entire unit ground floor </span><span>68</span></label>
//       <label><span><input type="checkbox"/> Elevator access </span><span>49</span></label>
//       <label><span><input type="checkbox"/> Wheelchair accessible </span><span>75</span></label>
//       <label><span><input type="checkbox"/> Adapted bath </span><span>13</span></label>
//       <label><span><input type="checkbox"/> Roll-in shower </span><span>18</span></label>
//       <label><span><input type="checkbox"/> Walk-in shower </span><span>39</span></label>
//       <label><span><input type="checkbox"/> Shower chair </span><span>14</span></label>
//     </div>
//   </div>
// </div>






//     </div>
//     <div className="col-lg-9">
//   <PropertyList properties={properties} />





//   {/* <PropertyList data={properties} />
//   <PropertyList data={properties} />
//   <PropertyList data={properties} /> */}


//         </div>
//     </div>
//     </div>






// </>



















        
//           </div>

// )

// }


// export default SearchResults;












































// const SearchResults = () => {
//   const [allProperties, setAllProperties] = useState([]);
//   const [properties, setProperties] = useState([]);
//   const [loading, setLoading] = useState(true);

//   const [selectedTypes, setSelectedTypes] = useState([]); // yahan empty mat rakho
//   const [budget, setBudget] = useState(50);

//   const navigate = useNavigate();

//   function filterApprovedProperties(properties, bookingData, selectedTypes1, budget1) {
//     if (budget1 === undefined) {
//       budget1 = budget;
//     }

//     return properties.data.properties
//       .filter((property) => property.status === "approved")
//       .map((property) => ({
//         ...property,
//         rooms: property.rooms
//           ? property.rooms.filter((room) => {
//               if (room.status !== "approved") return false;

//               const price =
//                 room.discount?.priceAfterDiscount && room.discount?.priceAfterDiscount > 0
//                   ? room.discount.priceAfterDiscount
//                   : room.nightlyPrice;

//               return price >= budget1;
//             })
//           : [],
//       }))
//       .filter((property) => property.rooms.length > 0)
//     .filter((property) => {
//   const cityMatch =
//     bookingData?.destination &&
//     property.city?.toLowerCase() === bookingData.destination.toLowerCase();

//   const categoryMatch =
//     bookingData?.selectedOption &&
//     property.category?.toLowerCase() === bookingData.selectedOption.toLowerCase();

//   const typeMatch =
//     selectedTypes1.length === 0
//       ? property.category === bookingData?.selectedOption
//       : selectedTypes1.includes(property.category);

//   // ✅ cityMatch to zaroori hai
//   // ✅ lekin category ya type dono me se ek match ho jaye to chalega
//   return cityMatch && (categoryMatch || typeMatch);
// });
//   }

//   useEffect(() => {
//     window.scrollTo(0, 0);
//     const bookingData = JSON.parse(localStorage.getItem("BookingDate")) || {};

//     if (!bookingData) {
//       navigate("/");
//       return;
//     }

//     // ✅ agar selectedTypes empty hai to usko bookingData.selectedOption se fill karo
//     if (selectedTypes.length === 0 && bookingData?.selectedOption) {
//       setSelectedTypes([bookingData.selectedOption]);
//     }

//     fetch("https://striking-dedication-production.up.railway.app/api/v1/public/properties", {
//       method: "GET",
//       headers: { Accept: "application/json", "Content-Type": "application/json" },
//     })
//       .then((res) => {
//         if (!res.ok) {
//           throw new Error(`HTTP error! status: ${res.status}`);
//         }
//         return res.json();
//       })
//       .then((data) => {
//         console.log(data)
//         setAllProperties(data);
//         const approvedData = filterApprovedProperties(
//           data,
//           bookingData,
//           selectedTypes.length > 0 ? selectedTypes : [bookingData.selectedOption],
//           budget
//         );
//         setProperties(approvedData);
//         setLoading(false);
//       })
//       .catch((err) => {
//         console.error("Error fetching properties:", err);
//         setLoading(false);
//       });
//   }, [navigate, budget]);

//   // ✅ slider change
//   const handleBudgetChange = (e) => {
//     const newBudget = Number(e.target.value);
//     setBudget(newBudget);

//     const bookingData = JSON.parse(localStorage.getItem("BookingDate"));
//     if (allProperties?.data) {
//       const approvedData = filterApprovedProperties(allProperties, bookingData, selectedTypes, newBudget);
//       setProperties(approvedData);
//     }
//   };

//   // ✅ type filter change
//   const handleTypeChange = (type) => {
//     let updatedTypes;

//     if (selectedTypes.includes(type)) {
//       updatedTypes = selectedTypes.filter((t) => t !== type);
//     } else {
//       updatedTypes = [...selectedTypes, type];
//     }

//     setSelectedTypes(updatedTypes);

//     const bookingData = JSON.parse(localStorage.getItem("BookingDate"));
//     if (allProperties?.data) {
//       const filtered = filterApprovedProperties(allProperties, bookingData, updatedTypes, budget);
//       setProperties(filtered);
//     }
//   };









//   function getRoomPriceForDate(room, date) {
//   const checkDate = new Date(date);

//   // 1️⃣ Discount check
//   if (room.discount?.priceAfterDiscount && room.discount?.validFrom && room.discount?.validTo) {
//     const from = new Date(room.discount.validFrom);
//     const to = new Date(room.discount.validTo);
//     if (checkDate >= from && checkDate <= to) {
//       return room.discount.priceAfterDiscount;
//     }
//   }

//   // 2️⃣ Calendar check
//   if (room.calendar?.length > 0) {
//     for (const entry of room.calendar) {
//       const entryStart = new Date(entry.startDate);
//       const entryEnd = new Date(entry.endDate);

//       if (checkDate >= entryStart && checkDate <= entryEnd) {
//         if (entry.status === "close") {
//           return null; // room closed
//         }
//         if (entry.status === "open" && entry.price != null) {
//           console.log(entry.status === "open" && entry.price != null )
//           return entry.price; // ✅ calendar price takes priority over nightlyPrice
//         }
//       }
//     }
//   }

//   // 3️⃣ Fallback to nightly price if no discount or calendar price
//   return room.nightlyPrice ?? null;
// }















import React, { useEffect, useState } from "react";

import { Link , useNavigate} from 'react-router-dom';
// import Ico from './iconBox';




import PropertyList from "./allProperties";
// import properties from "./Yovho.properties.json";
import SearchBar from "./SearchBar";
import  "./sidebar.css";




import Slider1 from '../img/Karachi-Travel-Guide-Travel-S-Helper-copy-1024x640.jpg';
import Slider2 from '../img/cover-image-2019-10-17T124521.228.jpg';





import smallReview1 from '../img/4 (1).jpg';


import About1 from '../img/9 (1).jpg';
import About2 from '../img/10 (1).jpg';
import About3 from '../img/8 (1).jpg';
import About4 from '../img/7 (1).jpg';

















const SearchResults = () => {
  const [allProperties, setAllProperties] = useState([]);
  const [properties, setProperties] = useState([]);
  const [loading, setLoading] = useState(true);

  const [selectedTypes, setSelectedTypes] = useState([]); // empty mat rakho
  const [budget, setBudget] = useState(50);

  const navigate = useNavigate();

  // ✅ per-day price priority logic
  function getRoomPriceForDate(room, date) {
    // 1. Discount check
    if (
      room.discount?.priceAfterDiscount &&
      room.discount?.validFrom &&
      room.discount?.validTo
    ) {
      const from = new Date(room.discount.validFrom);
      const to = new Date(room.discount.validTo);
      if (date >= from && date <= to) {
        return room.discount.priceAfterDiscount;
      }
    }

    // 2. Calendar check
    if (room.calendar?.length > 0) {
      for (const entry of room.calendar) {
          console.log(room)
        const entryStart = new Date(entry.startDate);
        const entryEnd = new Date(entry.endDate);
          // console.log(date,entryStart,entryEnd)

        if (date >= entryStart && date <= entryEnd) {
          // console.log(date,entryStart,entryEnd)
          if (entry.status === "close") {
            return null; // ❌ room closed
          }
          if (entry.status === "open" && entry.price) {
            console.log(entry.status === "open" && entry.price != null )

            return entry.price;
          }
        }
      }
    }

    // 3. fallback nightly price
    return room.nightlyPrice;
  }













  // ✅ check availability + total price for booking range
  function isRoomAvailableWithPrice(room, checkIn, checkOut) {
    const start = new Date(checkIn);
    const end = new Date(checkOut);

    let totalPrice = 0;
    let available = true;

    for (let d = new Date(start); d < end; d.setDate(d.getDate() + 1)) {
      const price = getRoomPriceForDate(room, new Date(d));
      if (price === null) {
        available = false; // ❌ closed day mila
        break;
      }

      totalPrice += price;
    }
    console.log(totalPrice,available)

    return { available, totalPrice };
  }

  // ✅ filter approved properties
  function filterApprovedProperties(properties, bookingData, selectedTypes1, budget1) {
    if (budget1 === undefined) {
      budget1 = budget;
    }
console.log(budget)
    return properties.data.properties
      .filter((property) => property.status === "approved")
      .map((property) => {
        const filteredRooms = property.rooms
          ? property.rooms.filter((room) => {
              if (room.status !== "approved") return false;

              if (!bookingData?.checkIn || !bookingData?.checkOut) return false;

              const { available, totalPrice } = isRoomAvailableWithPrice(
                room,
                bookingData.checkIn,
                bookingData.checkOut
              );

              if (!available) return false;



      // ✅ Room-level remaining check
            if (room.roomDetails?.dateWiseRemaining?.length > 0) {
              const remainingArray = room.roomDetails.dateWiseRemaining;
              const demandRooms = bookingData.rooms || 1;
              let enoughRemaining = true;

              const start = new Date(bookingData.checkIn);
              const end = new Date(bookingData.checkOut);

              for (let d = new Date(start); d < end; d.setDate(d.getDate() + 1)) {
                const day = remainingArray.find((r) => {
                  const dayDate = new Date(r.date);
                  return (
                    dayDate.getFullYear() === d.getFullYear() &&
                    dayDate.getMonth() === d.getMonth() &&
                    dayDate.getDate() === d.getDate()
                  );
                });

                // Agar day entry nahi hai → assume available
                if (day && day.remaining < demandRooms) {
                  enoughRemaining = false;
                  break;
                }
              }

              if (!enoughRemaining) return false; // reject room if not enough remaining
            }

            // ✅ room-level remaining check
            // const demandRooms = bookingData.rooms || 1;
            // const start = new Date(bookingData.checkIn);
            // const end = new Date(bookingData.checkOut);
            // let enoughRemaining = true;

            // for (let d = new Date(start); d < end; d.setDate(d.getDate() + 1)) {
            //   const day = room.roomDetails?.dateWiseRemaining?.find(
            //     (r) => {
            //       const dayDate = new Date(r.date);
            //       return (
            //         dayDate.getFullYear() === d.getFullYear() &&
            //         dayDate.getMonth() === d.getMonth() &&
            //         dayDate.getDate() === d.getDate()
            //       );
            //     }
            //   );
            //   if (!day || day.remaining < demandRooms) {
            //     enoughRemaining = false;
            //     break;
            //   }
            // }
            // if (!enoughRemaining) return false;


              // ✅ budget check
              return totalPrice >= budget1;
            })
          : [];

        return { ...property, rooms: filteredRooms };
      })
      .filter((property) => property.rooms.length > 0)
      .filter((property) => {
        console.log(property)
        const cityMatch =
          bookingData?.destination &&
          property.city?.toLowerCase() === bookingData.destination.toLowerCase();
          console.log(property.city?.toLowerCase() , bookingData.destination.toLowerCase())

        const categoryMatch =
          bookingData?.selectedOption &&
          property.category?.toLowerCase() === bookingData.selectedOption.toLowerCase();

          console.log(property.category?.toLowerCase() , bookingData.selectedOption.toLowerCase())
        const typeMatch =
          selectedTypes1.length === 0
            ? property.category === bookingData?.selectedOption
            : selectedTypes1.includes(property.category);
          console.log(property.category , bookingData?.selectedOption , selectedTypes1," fgdg ", selectedTypes1.includes(property.category))

        return cityMatch && (categoryMatch || typeMatch);
      });
  }

  useEffect(() => {
    window.scrollTo(0, 0);
    const bookingData = JSON.parse(localStorage.getItem("BookingDate")) || {};

    if (!bookingData) {
      navigate("/");
      return;
    }

    if (selectedTypes.length === 0 && bookingData?.selectedOption) {
      setSelectedTypes([bookingData.selectedOption]);
    }

    fetch("https://striking-dedication-production.up.railway.app/api/v1/public/properties", {
      method: "GET",
      headers: { Accept: "application/json", "Content-Type": "application/json" },
    })
      .then((res) => {
        if (!res.ok) {
          throw new Error(`HTTP error! status: ${res.status}`);
        }
        return res.json();
      })
      .then((data) => {
        console.log(data)
        setAllProperties(data);
        const approvedData = filterApprovedProperties(
          data,
          bookingData,
          selectedTypes.length > 0 ? selectedTypes : [bookingData.selectedOption],
          budget
        );
        setProperties(approvedData);
        setLoading(false);
      })
      .catch((err) => {
        console.error("Error fetching properties:", err);
        setLoading(false);
      });
  }, [navigate, budget]);

  const handleBudgetChange = (e) => {
    const newBudget = Number(e.target.value);
    setBudget(newBudget);

    const bookingData = JSON.parse(localStorage.getItem("BookingDate"));
    if (allProperties?.data) {
      const approvedData = filterApprovedProperties(
        allProperties,
        bookingData,
        selectedTypes,
        newBudget
      );
      setProperties(approvedData);
    }
  };

  const handleTypeChange = (type) => {
    let updatedTypes;

    if (selectedTypes.includes(type)) {
      updatedTypes = selectedTypes.filter((t) => t !== type);
    } else {
      updatedTypes = [...selectedTypes, type];
    }
      console.log(selectedTypes,updatedTypes)
    setSelectedTypes(updatedTypes);

    const bookingData = JSON.parse(localStorage.getItem("BookingDate"));
    if (allProperties?.data) {
      console.log("1")
      const filtered = filterApprovedProperties(
        allProperties,
        bookingData,
        updatedTypes,
        budget
      );
      setProperties(filtered);
    }
  };













if (loading) return <p>Loading...</p>;


return(


         <div>
      

<>

      <SearchBar />

  <br />


 <div className="container">
    <div className="row">
    <div className="col-lg-3">



<div class="sidebar">
  {/* <!-- Map --> */}
  {/* <div class="map-container">
    <img src="https://via.placeholder.com/300x150.png?text=Map+Preview" alt="Map"/>
    <button>Show on map</button>
  </div> */}

  {/* <!-- Filters --> */}
  <div class="filter-section">
    <h3>Filter by:</h3>

    {/* <!-- Budget --> */}
    <div class="budget-range">
      <strong>Your budget {budget} (per night)</strong><br/>
      PKR 5,000 – PKR 100,000+
      <input type="range" min="50" max="100000" 
                           value={budget}
                    onChange={handleBudgetChange}
         style={{width:"100%"}}/>
    </div>

    {/* <!-- General Options --> */}
    

    {/* <!-- Property Type --> */}
    <h4>Property Type</h4>
                <div className="filter-options">
                  {["Hotel", "Apartment Stay", "Home Stay", "Hostels"].map((type) => (
                    <label key={type}>
                      <span>
                        <input
                          type="checkbox"
                          checked={selectedTypes.includes(type)}
                          onChange={() => handleTypeChange(type)}
                        />{" "}
                        {type}
                      </span>
                    </label>
                  ))}
                </div>
{/* <hr />
<hr />
<div class="filter-options">
      <label><span><input type="checkbox"/> No prepayment </span><span>349</span></label>
      <label><span><input type="checkbox"/> Free cancellation </span><span>100</span></label>
      <label><span><input type="checkbox"/> Hot tub </span><span>12</span></label>
      <label><span><input type="checkbox"/> Sauna </span><span>5</span></label>
      <label><span><input type="checkbox"/> Toilet </span><span>288</span></label>
      <label><span><input type="checkbox"/> Towels </span><span>287</span></label>
    </div> */}

<hr />
<hr />
    {/* <!-- Property Facilities --> */}
    <h4>Property Facilities</h4>
    <div class="filter-options">
      <label><span><input type="checkbox"/> Parking </span><span>475</span></label>
      <label><span><input type="checkbox"/> Restaurant </span><span>70</span></label>
      <label><span><input type="checkbox"/> Room service </span><span>191</span></label>
      <label><span><input type="checkbox"/> 24-hour front desk </span><span>178</span></label>
      <label><span><input type="checkbox"/> Fitness center </span><span>28</span></label>
      <label><span><input type="checkbox"/> Non-smoking rooms </span><span>233</span></label>
      <label><span><input type="checkbox"/> Airport shuttle </span><span>131</span></label>
      <label><span><input type="checkbox"/> Spa </span><span>13</span></label>
      <label><span><input type="checkbox"/> Hot tub/Jacuzzi </span><span>44</span></label>
      <label><span><input type="checkbox"/> Free Wifi </span><span>345</span></label>
      <label><span><input type="checkbox"/> EV charging </span><span>8</span></label>
      <label><span><input type="checkbox"/> Wheelchair accessible </span><span>41</span></label>
    </div>
<hr />
<hr />
    {/* <!-- Property Rating --> */}
    <h4>Property Rating</h4>
    <div class="filter-options">
      <label><span><input type="checkbox"/> 1 star </span><span>8</span></label>
      <label><span><input type="checkbox"/> 2 stars </span><span>21</span></label>
      <label><span><input type="checkbox"/> 3 stars </span><span>110</span></label>
      <label><span><input type="checkbox"/> 4 stars </span><span>31</span></label>
      <label><span><input type="checkbox"/> 5 stars </span><span>16</span></label>
    </div>
<hr />
<hr />
    {/* <!-- Review Score --> */}
    <h4>Review Score</h4>
    <div class="filter-options">
      <label><span><input type="checkbox"/> Wonderful: 9+ </span><span>91</span></label>
      <label><span><input type="checkbox"/> Very Good: 8+ </span><span>147</span></label>
      <label><span><input type="checkbox"/> Good: 7+ </span><span>205</span></label>
      <label><span><input type="checkbox"/> Pleasant: 6+ </span><span>232</span></label>
    </div>
<hr />
<hr />
    {/* <!-- Reasons to Visit --> */}
    {/* <h4>Reasons to Visit</h4>
    <div class="filter-options">
      <label><span><input type="checkbox"/> Business </span><span>175</span></label>
      <label><span><input type="checkbox"/> Beaches </span><span>66</span></label>
      <label><span><input type="checkbox"/> Sunny Weather </span><span>63</span></label>
      <label><span><input type="checkbox"/> Family Friendly Trips </span><span>50</span></label>
      <label><span><input type="checkbox"/> Carnival </span><span>24</span></label>
      <label><span><input type="checkbox"/> Budget Friendly </span><span>6</span></label>
      <label><span><input type="checkbox"/> Nature </span><span>4</span></label>
      <label><span><input type="checkbox"/> Tropical Weather </span><span>4</span></label>
      <label><span><input type="checkbox"/> Glacier Tours </span><span>3</span></label>
      <label><span><input type="checkbox"/> Luxury Shopping </span><span>2</span></label>
    </div>
<hr />
<hr /> */}
    {/* <!-- Neighborhood --> */}
    {/* <h4>Neighborhood</h4>
    <div class="filter-options">
      <label><span><input type="checkbox"/> D.H.A. </span><span>104</span></label>
      <label><span><input type="checkbox"/> PECHS </span><span>38</span></label>
      <label><span><input type="checkbox"/> Gulshan-E-Jamal </span><span>34</span></label>
      <label><span><input type="checkbox"/> Clifton </span><span>33</span></label>
      <label><span><input type="checkbox"/> Saddar Town </span><span>8</span></label>
      <label><span><input type="checkbox"/> Shahrah-e-Faisal </span><span>8</span></label>
      <label><span><input type="checkbox"/> Bath Island </span><span>4</span></label>
      <label><span><input type="checkbox"/> Kehkashan </span><span>2</span></label>
    </div>
<hr />
<hr /> */}
    {/* <!-- Room Facilities --> */}
    <h4>Room Facilities</h4>
    <div class="filter-options">
      <label><span><input type="checkbox"/> Sea view </span><span>26</span></label>
      <label><span><input type="checkbox"/> Balcony </span><span>319</span></label>
      <label><span><input type="checkbox"/> Private bathroom </span><span>392</span></label>
      <label><span><input type="checkbox"/> Private pool </span><span>8</span></label>
      <label><span><input type="checkbox"/> Air conditioning </span><span>481</span></label>
    </div>
<hr />
<hr />
    {/* <!-- Accessibility --> */}
    {/* <h4>Accessibility</h4>
    <div class="filter-options">
      <label><span><input type="checkbox"/> Toilet with grab rails </span><span>18</span></label>
      <label><span><input type="checkbox"/> Raised toilet </span><span>21</span></label>
      <label><span><input type="checkbox"/> Lowered sink </span><span>17</span></label>
      <label><span><input type="checkbox"/> Bathroom emergency cord </span><span>10</span></label>
      <label><span><input type="checkbox"/> Visual aids (Braille) </span><span>7</span></label>
      <label><span><input type="checkbox"/> Visual aids (tactile) </span><span>7</span></label>
      <label><span><input type="checkbox"/> Auditory guidance </span><span>11</span></label>
      <label><span><input type="checkbox"/> Entire unit ground floor </span><span>68</span></label>
      <label><span><input type="checkbox"/> Elevator access </span><span>49</span></label>
      <label><span><input type="checkbox"/> Wheelchair accessible </span><span>75</span></label>
      <label><span><input type="checkbox"/> Adapted bath </span><span>13</span></label>
      <label><span><input type="checkbox"/> Roll-in shower </span><span>18</span></label>
      <label><span><input type="checkbox"/> Walk-in shower </span><span>39</span></label>
      <label><span><input type="checkbox"/> Shower chair </span><span>14</span></label>
    </div> */}
  </div>
</div>






    </div>
    <div className="col-lg-9">
  <PropertyList properties={properties} />





  {/* <PropertyList data={properties} />
  <PropertyList data={properties} />
  <PropertyList data={properties} /> */}


        </div>
    </div>
    </div>






</>



















        
          </div>

)

}


export default SearchResults;
